import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @file Created on Wed Jul 25 2018
 * @author BPo
 */


import { Utils } from '@logio/common-be-fe';
import * as Sentry from '@sentry/browser';
import { action, observable } from 'mobx';
import { CONSTANTS } from '../../../constants';
import { LoadingState } from '../../api/LoadingState';
import logger from '../../logger';
import { local, session } from '../../storage';
import { ProfileLayer } from '../../transportLayers/user/ProfileLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { injectScript } from '../../utils';
/**
 * Keycloak identity and access management store
 */

export var KeycloakStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(KeycloakStore, _BaseStore);

  function KeycloakStore() {
    var _this;

    _classCallCheck(this, KeycloakStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeycloakStore).apply(this, arguments));
    _this.profileLayer = new ProfileLayer();
    _this.name = StoreName.Keycloak;
    _this.errorStore = _this.rootStore.getStore(StoreName.Error);
    _this.profileStore = _this.rootStore.getStore(StoreName.Profile);
    _this.loadingState = LoadingState.Pending;
    _this.isAuthenticated = false;

    _this.hasPermission = function (permissionType) {
      if (!_this.profileStore.profile) {
        return true;
      }

      return _this.profileStore.profile.permissions.some(function (permission) {
        return permission.name === permissionType.name;
      });
    };

    _this.userHasPermissions = function (permissionTypes, some) {
      return some ? permissionTypes.some(function (permissionType) {
        return _this.hasPermission(permissionType);
      }) : permissionTypes.every(function (permissionType) {
        return _this.hasPermission(permissionType);
      });
    };
    /**
     * Changes loading state
     * @param state should represent data
     */


    _this.setLoadingState = function (state) {
      _this.loadingState = state;
    };

    return _this;
  }
  /**
   * Call this method when user is logged in / out
   */


  _createClass(KeycloakStore, [{
    key: "setAuthenticated",
    value: function setAuthenticated(authenticated) {
      this.isAuthenticated = authenticated;
    }
    /**
     * Initialize the keycloak adapter
     */

  }, {
    key: "initialize",
    value: function initialize() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var tokens, initOptions, authenticated, user;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (window.Keycloak) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return injectScript("".concat(CONSTANTS.KEYCLOAK.CONFIG.url, "/js/keycloak.js"));

              case 3:
                this.keycloak = window.Keycloak(CONSTANTS.KEYCLOAK.CONFIG);

              case 4:
                if (Utils.isValueMissing(CONSTANTS.KEYCLOAK.CONFIG.bearer)) {
                  _context.next = 7;
                  break;
                }

                // this.setLoadingState(LoadingState.Success);
                this.setAuthenticated(true);
                return _context.abrupt("return");

              case 7:
                tokens = getTokensFromStorage();
                initOptions = Object.assign(Object.assign({}, CONSTANTS.KEYCLOAK.INIT_OPTIONS), tokens);
                _context.prev = 9;
                _context.next = 12;
                return keycloakPromiseToStandardPromise(this.keycloak.init(initOptions));

              case 12:
                authenticated = _context.sent;

                if (!authenticated) {
                  _context.next = 20;
                  break;
                }

                _context.next = 16;
                return this.profileStore.loadUserProfile();

              case 16:
                user = _context.sent;
                this.setAuthenticated(true); // Sets user context for sentry logging

                Sentry.setUser({
                  id: user.id,
                  name: user.name,
                  username: user.username
                });
                addTokensToStorage(this.keycloak);

              case 20:
                _context.next = 28;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](9);
                this.setAuthenticated(false);
                logger.error('Keycloak authentication failed');
                this.errorStore.setError('Keycloak authentication failed');
                this.setLoadingState(LoadingState.Error);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 22]]);
      }));
    }
    /**
     * Returns the base64 encoded token that can be sent in the Authorization header in requests to services.
     */

  }, {
    key: "getToken",
    value: function getToken() {
      return this.keycloak.token || null;
    }
    /**
     * Redirects to logout.
     * @param {string=} redirectUri Specifies the uri to redirect to after logout.
     */

  }, {
    key: "logout",
    value: function logout() {
      var redirectUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.origin;
      removeTokensFromStorage();
      this.keycloak.logout({
        redirectUri: redirectUri
      });
    }
  }, {
    key: "refreshToken",
    value: function refreshToken() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.keycloak.updateToken(5);

              case 2:
                addTokensToStorage(this.keycloak);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return KeycloakStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Number)], KeycloakStore.prototype, "loadingState", void 0);

__decorate([observable, __metadata("design:type", Object)], KeycloakStore.prototype, "isAuthenticated", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean]), __metadata("design:returntype", void 0)], KeycloakStore.prototype, "setAuthenticated", null);

__decorate([action, __metadata("design:type", Object)], KeycloakStore.prototype, "setLoadingState", void 0);

function getTokensFromStorage() {
  var tokens = {};

  if (CONSTANTS.KEYCLOAK.TOKENS_STORAGE === 'local') {
    tokens.token = local.get(CONSTANTS.KEYCLOAK.STORAGE_TOKEN);
    tokens.refreshToken = local.get(CONSTANTS.KEYCLOAK.STORAGE_REFRESH_TOKEN);
    tokens.idToken = local.get(CONSTANTS.KEYCLOAK.STORAGE_ID_TOKEN);
  } else if (CONSTANTS.KEYCLOAK.TOKENS_STORAGE === 'session') {
    tokens.token = session.get(CONSTANTS.KEYCLOAK.STORAGE_TOKEN);
    tokens.refreshToken = session.get(CONSTANTS.KEYCLOAK.STORAGE_REFRESH_TOKEN);
    tokens.idToken = session.get(CONSTANTS.KEYCLOAK.STORAGE_ID_TOKEN);
  }

  return tokens;
}

function addTokensToStorage(tokens) {
  if (CONSTANTS.KEYCLOAK.TOKENS_STORAGE === 'local') {
    local.add(CONSTANTS.KEYCLOAK.STORAGE_TOKEN, tokens.token);
    local.add(CONSTANTS.KEYCLOAK.STORAGE_REFRESH_TOKEN, tokens.refreshToken);
    local.add(CONSTANTS.KEYCLOAK.STORAGE_ID_TOKEN, tokens.idToken);
  } else if (CONSTANTS.KEYCLOAK.TOKENS_STORAGE === 'session') {
    session.add(CONSTANTS.KEYCLOAK.STORAGE_TOKEN, tokens.token);
    session.add(CONSTANTS.KEYCLOAK.STORAGE_REFRESH_TOKEN, tokens.refreshToken);
    session.add(CONSTANTS.KEYCLOAK.STORAGE_ID_TOKEN, tokens.idToken);
  }
}

function removeTokensFromStorage() {
  if (CONSTANTS.KEYCLOAK.TOKENS_STORAGE === 'local') {
    local.remove(CONSTANTS.KEYCLOAK.STORAGE_TOKEN);
    local.remove(CONSTANTS.KEYCLOAK.STORAGE_REFRESH_TOKEN);
    local.remove(CONSTANTS.KEYCLOAK.STORAGE_ID_TOKEN);
  } else if (CONSTANTS.KEYCLOAK.TOKENS_STORAGE === 'session') {
    session.remove(CONSTANTS.KEYCLOAK.STORAGE_TOKEN);
    session.remove(CONSTANTS.KEYCLOAK.STORAGE_REFRESH_TOKEN);
    session.remove(CONSTANTS.KEYCLOAK.STORAGE_ID_TOKEN);
  }
}

function keycloakPromiseToStandardPromise(promise) {
  return new Promise(function (resolve, reject) {
    promise.success(resolve).error(reject);
  });
}